import "./index.scss";
import "react-smartbanner/dist/main.css";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import i18n from "i18next";
import React from "react";
import ReactDOM from "react-dom/client";
import { initReactI18next } from "react-i18next";
import SmartBanner from "react-smartbanner";

import { ampli } from "./ampli";
import { App } from "./App";
import { registerServiceWorker } from "./firebase/firebase";
import reportWebVitals from "./reportWebVitals";
import { development, production } from "./setup/constants";
import { DSN_SENTRY } from "./setup/constants";
import {
  isAppAuthenticated,
  isLoggedIn,
  logOut,
  UserContext,
} from "./setup/context/authContext";
import * as ar from "./translations/ar.json";

Sentry.init({
  dsn: DSN_SENTRY,
  integrations: [new BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

ampli.load({
  environment: process.env.NODE_ENV === development ? development : production,
});

i18n.use(initReactI18next).init({
  resources: {
    ar: {
      translation: ar,
    },
  },
});

i18n.changeLanguage("ar");

root.render(
  <React.StrictMode>
    <SmartBanner
      title={"Waffy وفّي"}
      author={"حمل التطبيق الآن واحفظ حقوقك"}
      button={"حمل الآن"}
    />
    <UserContext.Provider
      value={{
        isLoggedIn: isLoggedIn,
        logOut: logOut,
        isAppAuthenticated: isAppAuthenticated,
      }}>
      <App />
    </UserContext.Provider>
  </React.StrictMode>
);
registerServiceWorker();
reportWebVitals();
